import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import {addPrefix} from "../../../utils/UriUtil";
import {number_format} from "../../../utils/formatter";
import {number} from "prop-types";

@connect(state => ({
    totalCount : state.post.item.totalCount,
    category: state.post.condition.category,
    visibility: state.post.condition.visibility,
    searchKeyword: state.post.condition.searchKeyword,
}), dispatch => ({
}))
class PostTitle extends Component {

    constructor(props) {
        super(props);
        this.findCategoryName = this.findCategoryName.bind(this);
    }


    findCategoryName(categoryId) {
        let categoryName =  '';

        const findMatchCategory = (item => {

            if (parseInt(item.id) == parseInt(categoryId)) {
                return true;
            } else {
                if(!item.leaf){
                    const finded = item.children.find(findMatchCategory);
                    if(finded)
                        return true;
                }
                return false;

            }
        });

        let selectedCategory = window.Config.blog.categories.find(findMatchCategory);

        if(selectedCategory) {

            if(parseInt(selectedCategory.id) != parseInt(categoryId)){
                selectedCategory = selectedCategory.children.find(findMatchCategory);
            }

            categoryName = selectedCategory.label;
        }
        return categoryName;
    }

    makeWriteUrl() {
        return addPrefix(`/manage/post/?returnURL=${location.pathname}`);
    }

    render() {

        const { category, visibility, searchKeyword, totalCount} = this.props;
        const categoryName = this.findCategoryName(category);

        if(((category != -3) && (category !== null)) || (visibility != 'all')){

            let label = [];
            let categoryLabel = "";
            let visibilityLabel = "";

            if(category != -3){
                categoryLabel = <span className="txt_result">{categoryName} </span>;
            }

            if(visibility != 'all') {
                if (visibility == 'visible')
                    visibilityLabel = '공개';
                else if (visibility == 'hidden')
                    visibilityLabel = '비공개';
                else if (visibility == 'protect')
                    visibilityLabel = '보호';

                visibilityLabel = <span className="txt_result">{visibilityLabel} </span>;
            }


            if(categoryLabel != '' && visibilityLabel != ''){
                label.push(categoryLabel);
                label.push(' 의 ');
                label.push(visibilityLabel);
            }else if(categoryLabel != '')
                label.push(categoryLabel);
            else
                label.push(visibilityLabel);

            return (
                <h3 className="tit_cont">
                    {label}
                     글
                    <span className="txt_count"> {number_format(totalCount)}</span>
                    <Link to={"?"} className="link_back">
                        <span className="ico_blog ico_back">초기 목록으로 돌아가기</span>
                    </Link>
                    <a href={this.makeWriteUrl()} className="link_write">
                        글 쓰기
                        <span className="ico_blog"/>
                    </a>
                </h3>);


        }else if(searchKeyword && searchKeyword != ''){

            return (
                <h3 className="tit_cont">
                    <span className="txt_result">'{searchKeyword}'</span> 검색결과
                    <span className="txt_count">{ (totalCount >= 0) ? number_format(totalCount): ''}</span>
                    <Link to={"?"} className="link_back">
                        <span className="ico_blog ico_back">검색 전으로 돌아가기</span>
                    </Link>
                    <a href={this.makeWriteUrl()} className="link_write">
                        글 쓰기
                        <span className="ico_blog"/>
                    </a>
                </h3>
            );
        }else{

            return (
                <h3 className="tit_cont">
                    글 관리
                    <span className="txt_count"> {number_format(totalCount)}</span>
                    <a href={this.makeWriteUrl()} className="link_write">
                        글 쓰기
                        <span className="ico_blog"/>
                    </a>
                </h3>
            );
        }
    }
}

export default PostTitle;
